import {isString, isObject, isArray} from './common_funcs'

export default {
    localGet(key) {
        let item = null

        try {
            item = JSON.parse(localStorage.getItem(key))
        } catch (ex) {
            item = null
        }

        return item == null || (typeof item) != 'object' || !('data' in item) ? null : item.data
    },
    localSet(key, val) {
        const type = typeof val
        const supportedTypes = ['boolean', 'string', 'number', 'object']
        const isArray = type == 'object' && val.constructor == Array
        const data = val != null && (isArray || supportedTypes.includes(type)) ? val : null

        try {
            localStorage.setItem(key, JSON.stringify({data}))
        } catch (ex) {
        }
    },
    localRemove(key) {
        try {
            localStorage.removeItem(key)
        } catch (ex) {
        }
    },
    // localStorage
    sessionGet(key) {
        let item = null

        try {
            item = JSON.parse(localStorage.getItem(key))
        } catch (ex) {
            item = null
        }

        return item == null || (typeof item) != 'object' || !('data' in item) ? null : item.data
    },
    sessionSet(key, val) {
        const type = typeof val
        const supportedTypes = ['boolean', 'string', 'number', 'object']
        const isArray = type == 'object' && val.constructor == Array
        const data = val != null && (isArray || supportedTypes.includes(type)) ? val : null

        try {
            localStorage.setItem(key, JSON.stringify({data}))
        } catch (ex) {
        }
    },
    sessionRemove(key) {
        try {
            localStorage.removeItem(key)
        } catch (ex) {
        }
    }
}



// WEBPACK FOOTER //
// ./src/libs/storage.js